// extracted by mini-css-extract-plugin
export default {"illustration":"style_illustration__lLcWk","formWrapper":"style_formWrapper__8JWxY","sentence":"style_sentence__AhvHj","backToLogin":"style_backToLogin__Mu06q"};